import type { Product, Purchase, User } from '../types'
import { products as seedProducts } from './fixtures'

/**
 * "Banco" em memória do modo mock, espelhado em localStorage para sobreviver a
 * um F5. Substituído por D1 quando o backend entrar.
 */

const STORAGE_KEY = 'mp.mockdb.v1'

interface MockState {
  user: User | null
  purchases: Purchase[]
  /** Produtos cadastrados manualmente pelo admin. */
  manualProducts: Product[]
}

const initialState: MockState = { user: null, purchases: [], manualProducts: [] }

function load(): MockState {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return { ...initialState }
    return { ...initialState, ...(JSON.parse(raw) as Partial<MockState>) }
  } catch {
    return { ...initialState }
  }
}

let state: MockState = load()

function persist() {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
  } catch {
    /* storage indisponível: o mock segue só em memória */
  }
}

export const mockDb = {
  get state() {
    return state
  },
  update(patch: Partial<MockState>) {
    state = { ...state, ...patch }
    persist()
  },
  /** Catálogo completo = produtos da API + cadastrados no admin. */
  allProducts(): Product[] {
    return [...state.manualProducts, ...seedProducts]
  },
  reset() {
    state = { ...initialState }
    persist()
  },
}

/** Simula latência de rede para que estados de carregamento sejam visíveis. */
export function delay<T>(value: T, ms = 320): Promise<T> {
  return new Promise((resolve) => setTimeout(() => resolve(value), ms))
}

export function makeId(prefix: string): string {
  return `${prefix}-${Math.random().toString(36).slice(2, 10)}`
}
